"use strict";
const articleProperties = require('../article/properties');
const hasCampaignWithTheLowestPrice = pricedArticle => pricedArticle.isCampaign &&
    pricedArticle.salesPrice === pricedArticle.campaignPrice;
function getTotalPricePerSalesUnit(pricedArticle) {
    if (pricedArticle.salesPrice === null ||
        pricedArticle.salesPrice === undefined) {
        return pricedArticle.salesPrice;
    }
    if (pricedArticle.orderUnit === 'weight') {
        return pricedArticle.salesPrice * pricedArticle.minWeightIncrement;
    }
    if (pricedArticle.orderUnit === 'single') {
        return pricedArticle.salesPrice;
    }
    return pricedArticle.salesPrice * (pricedArticle.colliSize || 1);
}
function getTotalListPricePerSalesUnit(pricedArticle) {
    if (pricedArticle.priceWithoutDiscount === null ||
        pricedArticle.priceWithoutDiscount === undefined) {
        return pricedArticle.priceWithoutDiscount;
    }
    if (pricedArticle.orderUnit === 'weight') {
        return (pricedArticle.priceWithoutDiscount * pricedArticle.minWeightIncrement);
    }
    if (pricedArticle.orderUnit === 'single') {
        return pricedArticle.priceWithoutDiscount;
    }
    return pricedArticle.priceWithoutDiscount * (pricedArticle.colliSize || 1);
}
function getViewModel(pricedArticle) {
    const getDisplayPriceComparison = () => {
        const caseUnitSize = pricedArticle.caseUnitSize || 1;
        if (pricedArticle.salesPrice === null ||
            pricedArticle.salesPrice === undefined) {
            return pricedArticle.salesPrice;
        }
        if (pricedArticle.priceComparisonUnit === 'liter') {
            return pricedArticle.salesPrice / (pricedArticle.volume * caseUnitSize);
        }
        if (pricedArticle.priceComparisonUnit === 'kg') {
            return pricedArticle.salesPrice / (pricedArticle.weight / 1000);
        }
        if (caseUnitSize > 1 &&
            pricedArticle.colliSize === 1 &&
            pricedArticle.orderUnit === 'package') {
            return pricedArticle.salesPrice / caseUnitSize;
        }
        return pricedArticle.salesPrice;
    };
    const getDisplayPriceComparisonUnit = () => {
        if (pricedArticle.salesPrice === null ||
            pricedArticle.salesPrice === undefined) {
            return '';
        }
        if (pricedArticle.priceComparisonUnit === 'liter') {
            return 'l';
        }
        if (pricedArticle.priceComparisonUnit === 'kg') {
            return 'kg';
        }
        return 'st';
    };
    const getDisplayTotalSalesPrice = () => {
        if (pricedArticle.salesPrice === null ||
            pricedArticle.salesPrice === undefined) {
            return pricedArticle.salesPrice;
        }
        return getTotalPricePerSalesUnit(pricedArticle);
    };
    const getDisplayTotalListPrice = () => {
        if (pricedArticle.priceWithoutDiscount === null ||
            pricedArticle.priceWithoutDiscount === undefined) {
            return pricedArticle.priceWithoutDiscount;
        }
        return getTotalListPricePerSalesUnit(pricedArticle);
    };
    const shouldHighlightPriceAsDiscounted = () => pricedArticle.displayDiscount > 0;
    const getPriceType = () => {
        if (!pricedArticle.priceType) {
            return '';
        }
        if (pricedArticle.priceType === 'campaign') {
            return 'Kampanj';
        }
        if (pricedArticle.priceType === 'tender') {
            return 'Anbud';
        }
        if (pricedArticle.priceType === 'tenderCampaign') {
            return 'Anbud, kampanj';
        }
        return '';
    };
    return {
        ...articleProperties.getViewModel(pricedArticle),
        displayTotalSalesPrice: getDisplayTotalSalesPrice(),
        displayTotalListPrice: getDisplayTotalListPrice(),
        displayPriceComparison: getDisplayPriceComparison(),
        displayPriceComparisonUnit: getDisplayPriceComparisonUnit(),
        shouldHighlightPriceAsDiscounted: shouldHighlightPriceAsDiscounted(),
        getPriceType: getPriceType(),
    };
}
module.exports = {
    ...articleProperties,
    getTotalPricePerSalesUnit,
    getViewModel,
    hasCampaignWithTheLowestPrice,
};
